
import { apis } from '@/services/api';
import { Thread, Network } from '@movilizame/networking';
import { Geocoding } from '@/services/geocoding';
import { executeOnceInTime } from '@/services/utility';
import { playSound } from '@/services/Audio';
import globalStore from '../../index';
import dialogs from '@/services/dialogs.js';
// import translate from '@/services/language';
import { LangManager } from '@/services/language';
import { TRIP_STATE, BACKEND_TRIP_STATE } from '../../mutation-types';
import router from '@/router';
import { isBlacklistedTokenError } from '@/services/api/authError';
import { reservationAdvanceAllowed, reservationAdvanceErrorMessage, canCancelReservation } from '@/services/reservation';

let pasajeroApi = apis.pasajerosApi;

function shouldStayOnReservasRoute () {
    const route = router && router.currentRoute;
    const routeName = route && route.name;
    return routeName === 'reservas';
}

function resetState (store) {
    store.commit('RESET_STATES');
}

const byPassError = (err) => {
    if (isBlacklistedTokenError(err)) {
        if (globalStore.getters['auth/checkLogin']) {
            globalStore.dispatch('auth/logout'); // Token inválido/blacklisted -> cerrar sesión.
        }
        return;
    }
    if (err && err.status === 403 && err.data === 'user-inactive') {
        dialogs.message(LangManager.translate('userInactive'), { duration: 10, estado: 'error' });
        globalStore.dispatch('auth/logout'); // Cierro sesión
    } else {
        return Promise.reject(err);
    }
};

function playNotification (store, tripId, action, sound, url) {
    let state = store.state.alreadyPlayedNotifications;
    console.log('playNotification', sound, state);
    if (globalStore.getters['cordova/foreground']) {
        if (tripId) {
            if (!state[action][tripId]) {
                if (sound) {
                    playSound(sound, url);
                }
            }
        } else {
            if (sound) {
                playSound(sound, url);
            }
        }
    }
    store.commit('SET_PLAYED_NOTIFICATONS', action, tripId);
}

function isReservationAdvanceAllowed (trip) {
    return reservationAdvanceAllowed(trip, globalStore.getters['company/config']);
}

/**
 * El chofer puede haber aprobado/rechazado beneficio residente/jubilado en el viaje;
 * el usuario en memoria queda desactualizado hasta refrescar desde API.
 */
function maybeRefreshPassengerUserForBeneficio () {
    const user = globalStore.getters['auth/user'];
    const settings = globalStore.getters['company/config'];
    if (!user || user.chofer) {
        return;
    }
    if (!settings || !settings.modulo_descuento_residente_jubilado || !user.tipo_beneficio) {
        return;
    }
    globalStore.dispatch('auth/refreshUser').catch(() => {});
}

function handlerNotification (store, notification) {
    let trip;
    console.log('notification handler', notification);
    switch (notification.url) {
        case 'aceptar':
            trip = store.state.pendingReservation || store.state.actualTrip;
            if (trip && (trip.id === parseInt(notification.viaje_id, 10))) {
                if (notification.trip) {
                    Object.assign(trip, notification.trip);
                }
                if (notification.trip && notification.trip.pago_reserva) {
                    trip.pago_reserva = notification.trip.pago_reserva;
                } else if (notification.trip && notification.trip.pagoReserva) {
                    trip.pago_reserva = notification.trip.pagoReserva;
                }
                store.commit('SET_PENDING_RESERVATION', trip.es_con_reserva ? trip : null);
                if (!trip.es_con_reserva) {
                    trip.frontState = TRIP_STATE.ACCEPTED;
                    store.commit('SET_ACTUAL_TRIP', trip);
                    calculateTripStatics(store, trip);
                } else {
                    store.commit('SET_ACTUAL_TRIP', null);
                }
                const sound = notification.sound || 'bell';
                playNotification(store, trip.id, 'passengerAccepted', sound, notification.url);
            }
            break;
        case 'reserva-proxima':
            if (notification.viaje_id) {
                const sound = notification.sound || 'taxi';
                playNotification(store, parseInt(notification.viaje_id, 10), 'reservationProximity', sound, notification.url);
            }
            if (notification.foreground && notification.content) {
                dialogs.message(notification.content, { duration: 12, estado: 'success' });
            }
            break;
        case 'cancelar':
            trip = store.state.actualTrip;
            if (trip && trip.id === parseInt(notification.viaje_id, 10)) {
                trip.frontState = TRIP_STATE.CANCELED_BY_DRIVER;
                store.commit('ADD_HISTORY_TRIP', trip);
                store.commit('SET_ACTUAL_TRIP', null);
                store.commit('SET_ACTUAL_TRIP_METADATA', null);
                const sound = notification.sound || 'cancel_pacman';
                playNotification(store, trip.id, 'passengerCanceled', sound, notification.url);
                if (notification.foreground) {
                    if (notification.trip) {
                        store.commit('SET_CANCELED_TRIP', notification.trip);
                        // cancelarVisto(); // Esto despues deberíamos analizar si debería hacerce acá, dentro del IF se ve
                        // al abrir frontend si estas en background, fuera del if, no se muestra el cartel al pasar a foreground.
                    }
                }
                if (!shouldStayOnReservasRoute()) {
                    router.push({
                        name: 'home'
                    });
                }
            }
            break;
        case 'llegando':
            trip = store.state.actualTrip;
            if (trip && trip.id === parseInt(notification.viaje_id, 10)) {
                // Reservation flow: don't enter "arrived" step until it's due and paid.
                if (isReservationAdvanceAllowed(trip)) {
                    trip.llegando = true;
                    store.commit('SET_ACTUAL_TRIP', trip);
                    calculateTripStatics(store, trip);
                    const sound = notification.sound || 'old_claxon';
                    playNotification(store, trip.id, 'passengerTaxiArrived', sound, notification.url);
                } else {
                    trip.llegando = false;
                    trip.frontState = TRIP_STATE.ACCEPTED;
                    store.commit('SET_ACTUAL_TRIP', trip);
                }
            }
            break;
        case 'nuevo-mensaje':
        case 'nuevo-audio':
            if (notification && notification._original && notification._original.additionalData && notification._original.additionalData.chat) {
                let m = notification._original.additionalData.chat;
                globalStore.commit('messages/SET_MESSAGE', m);
                const sound = notification.sound || 'new_message';
                playNotification(store, null, 'newMessage', sound, notification.url);
            }
            break;
        case 'chofer-finaliza':
            console.log('chofer-finaliza', notification);
            // playNotification(store, parseInt(notification.viaje_id, 10), 'driverTripFinish', 'bell');
            dialogs.message(notification.content, { duration: 10, estado: 'error' });
            break;
        case 'tarifa-actualizada': {
            const viajeIdRaw = notification.viaje_id !== undefined && notification.viaje_id !== null
                ? notification.viaje_id
                : (notification.additionalData && notification.additionalData.viaje_id);
            const tripPayload = notification.trip || (notification.additionalData && notification.additionalData.trip);
            trip = store.state.actualTrip;
            if (trip && viajeIdRaw !== undefined && viajeIdRaw !== null && trip.id === parseInt(viajeIdRaw, 10) && tripPayload && tripPayload.precio !== undefined && tripPayload.precio !== null) {
                trip.precio = tripPayload.precio;
                store.commit('SET_ACTUAL_TRIP', trip);
            }
            break;
        }
    }
}

const debounceDirectionsService = executeOnceInTime((store, origin, destination) => {
    // Get geocoding runtime from settings, default to 'google'
    let settings = globalStore.getters['company/config'];
    let runtime = (settings && settings.modulo_geocoding) || 'google';
    let geocoding = new Geocoding(runtime);
    return geocoding.calculateRoute(origin, destination).then(data => {
        let actualTrip = store.state.actualTrip;
        if (actualTrip) {
            store.commit('SET_ACTUAL_TRIP_METADATA', data);
        }
    }).catch(byPassError);
}, 60000);

function createTrip (store, data) {
    return pasajeroApi.createTrip(data).then((trip) => {
        if (trip.es_con_reserva) {
            store.commit('SET_PENDING_RESERVATION', trip);
            store.commit('SET_ACTUAL_TRIP', null);
        } else {
            trip.frontState = TRIP_STATE.PENDING;
            store.commit('SET_ACTUAL_TRIP', trip);
        }
        store.commit('messages/SET_CURRENT_CONVERSATION', trip.id, { root: true });
        abortLastCheckState(); // Abortamos un chekState perdido
        return trip;
    }).catch(byPassError);
}

function crearPreferenciaReserva (store, data) {
    return pasajeroApi.crearPreferenciaReserva(data);
}

function upgradeChofer (store, data) {
    return pasajeroApi.upgradeChofer(data).then((data) => {
        console.log(data);
    }).catch(byPassError);
}

function getBeneficiosCatalogo (store, data) {
    return pasajeroApi.getBeneficiosCatalogo(data).catch(byPassError);
}

function crearTarjetaBeneficio (store, data) {
    return pasajeroApi.crearTarjetaBeneficio(data);
}

function getMisTarjetasBeneficio (store, data) {
    return pasajeroApi.getMisTarjetasBeneficio(data).catch(byPassError);
}

function canjearTarjetaBeneficio (store, data) {
    return pasajeroApi.canjearTarjetaBeneficio(data);
}

function syncPendingReservation (store, reserva) {
    if (reserva && reserva.es_con_reserva) {
        const pago = reserva.pago_reserva || reserva.pagoReserva;
        if (pago && pago.status === 'approved') {
            store.commit('SET_PENDING_RESERVATION', null);
            return;
        }
        store.commit('SET_PENDING_RESERVATION', reserva);
        store.commit('SET_ACTUAL_TRIP', null);
    } else if (!reserva) {
        store.commit('SET_PENDING_RESERVATION', null);
    }
}

function handleReservationRejected (store, viajeCancelado) {
    const pending = store.state.pendingReservation;
    if (!viajeCancelado || !viajeCancelado.es_con_reserva) {
        return false;
    }
    if (!pending || pending.id !== viajeCancelado.id) {
        return false;
    }
    playNotification(store, viajeCancelado.id, 'passengerCanceled', 'cancel_pacman');
    store.commit('SET_PENDING_RESERVATION', null);
    store.commit('SET_ACTUAL_TRIP', null);
    store.commit('ADD_HISTORY_TRIP', viajeCancelado);
    dialogs.message(LangManager.translate('reservaNoAceptadaMensaje'), { duration: 15, estado: 'error' });
    return true;
}

function handleState (store, data) {
    // [TODO] Call handle notification
    if (!store.state.hasFirstRemoteState) {
        store.commit('SET_FIRST_REMOTE_STATE');
    }

    if (Object.prototype.hasOwnProperty.call(data, 'reservaActiva')) {
        syncPendingReservation(store, data.reservaActiva || null);
    }

    let actualTrip = store.state.actualTrip;
    let trip = data.viaje;
    // No hay viaje actual
    if (trip) {
        if (!actualTrip) {
            let history = store.state.tripsHistory.find(item => item.id === trip.id);
            if (history && (history.frontState === TRIP_STATE.CANCELED_BY_USER || history.frontState === TRIP_STATE.CANCELED_BY_DRIVER || history.frontState === TRIP_STATE.FINISH || history.frontState === TRIP_STATE.TIMEOUT)) {
                // Agregue el caso "canceled_by_driver", este caso se da cuando el cancelar llega por notificación
                // Viaje fue cancelado o ya finalizo pero no llego al servidor
                // No hacemos nada, la app sola vuelve al estado anterior si falla el cancel
            } else {
                // Cerramos la app y la volvimos abrir. Por ahora no tenemos en cuenta de persistir algunos datos.
                if (!trip.comentario_rechazo) {
                    if (!trip.chofer_id) {
                        trip.frontState = TRIP_STATE.PENDING;
                    } else {
                        if (trip.pasajeroAbordo) {
                            trip.frontState = TRIP_STATE.RIDEUP;
                        } else {
                            trip.frontState = TRIP_STATE.ACCEPTED;
                            calculateTripStatics(store, trip);
                        }
                    }
                    // Reservation deferred-payment: don't show ride-up UI until due and paid.
                    if (!isReservationAdvanceAllowed(trip)) {
                        trip.llegando = false;
                        trip.pasajeroAbordo = false;
                        trip.frontState = TRIP_STATE.ACCEPTED;
                    }
                    store.commit('SET_ACTUAL_TRIP', trip);
                    store.commit('messages/SET_CURRENT_CONVERSATION', trip.id, { root: true });
                    store.dispatch('messages/getMessages', { chatId: trip.id }, {root: true});
                }
            }
        } else {
            if (actualTrip.id === trip.id) { // Por empezar chequeemos que el actualtrip y el trip que llego son el mismo, quizas es un estado anterior
                if (actualTrip.frontState === TRIP_STATE.PENDING && trip.chofer) { // El viaje pendiente paso a aceptado
                    playNotification(store, trip.id, 'passengerAccepted', 'old_claxon');
                    trip.frontState = TRIP_STATE.ACCEPTED;
                } else if (actualTrip.frontState === TRIP_STATE.ACCEPTED && !trip.chofer) { // Llego un handlestate atrasado.
                    trip = actualTrip;
                } else if (!trip.llegando && actualTrip.llegando) { // LLegando esta en TRUE por notificación
                    trip.llegando = true;
                    playNotification(store, trip.id, 'passengerTaxiArrived', 'old_claxon');
                } else if (!actualTrip.llegando && trip.llegando) { // Llegando esta en TRUE por checkState
                    playNotification(store, trip.id, 'passengerTaxiArrived', 'old_claxon');
                    trip.frontState = actualTrip.frontState;
                } else if (globalStore.getters['company/config'].modulo_flujo_tipo_uber && trip.llegando && actualTrip.frontState === TRIP_STATE.ACCEPTED && trip.estado === BACKEND_TRIP_STATE.ABORDADO) {
                    trip.frontState = TRIP_STATE.RIDEUP;
                } else if (globalStore.getters['company/config'].modulo_flujo_tipo_uber && trip.estado === BACKEND_TRIP_STATE.FINALIZADO) {
                    trip.frontState = TRIP_STATE.ARRIVED_TO_DESTINATION;
                } else { // refresh de accepted, rideup, pending - si la logica funciona bien no hace falta hacer la asignación de frontstate
                    trip.frontState = actualTrip.frontState;
                }
                if (!isReservationAdvanceAllowed(trip)) {
                    trip.llegando = false;
                    trip.pasajeroAbordo = false;
                    trip.frontState = TRIP_STATE.ACCEPTED;
                }
                if (trip.frontState === TRIP_STATE.ACCEPTED) {
                    calculateTripStatics(store, trip);
                }
                store.commit('SET_ACTUAL_TRIP', trip);
                store.commit('messages/SET_CURRENT_CONVERSATION', trip.id, { root: true });
            } else {
                if (trip.id > actualTrip.id) { // Caso extremo, seteamos el nuevo trip, borramos el viejo y llamamos el handle nuevamente
                    store.commit('SET_ACTUAL_TRIP', null);
                    console.error('ERROR: actualTrip no es el trip actual');
                    handleState(store, data);
                    return;
                } // El else de este IF, es el caso de que un estado anterior llego tarde, por lo tanto lo ignoro.
            }
        }
    } else { // [TODO] [CHECK] Este estado es peligroso, debría exisiter un time_out visto como en el cancelar -> imaginemos el
        // siguiente caso, solicito un viaje, un handlestate anterior a la soliciutd justo aparece, con ningun viaje, mi
        // nuevo viaje pedio será cancelado, lo que es un comportamiento no deseado.
        const pendingReserva = store.state.pendingReservation;
        if (actualTrip && actualTrip.frontState === TRIP_STATE.PENDING && !actualTrip.es_con_reserva && !pendingReserva) {
            // Timeout trip (viajes inmediatos, no reservas)
            playNotification(store, actualTrip.id, 'passengerCanceled', 'cancel_pacman');
            actualTrip.frontState = TRIP_STATE.TIMEOUT;
            store.commit('ADD_HISTORY_TRIP', actualTrip);
            store.commit('SET_ACTUAL_TRIP', null);
            if (!shouldStayOnReservasRoute()) {
                router.push({
                    name: 'home'
                });
            }
        }
    }
    if (data.viajeCancelado) {
        if (!handleReservationRejected(store, data.viajeCancelado)) {
            if (actualTrip) {
                if (actualTrip.id === data.viajeCancelado.id) { // Si el viaje cancelado de backend, es mi viaje actual, lo mando a dormir
                    playNotification(store, actualTrip.id, 'passengerCanceled', 'cancel_pacman');
                    actualTrip.frontState = TRIP_STATE.CANCELED_BY_DRIVER;
                    store.commit('ADD_HISTORY_TRIP', actualTrip);
                    store.commit('SET_ACTUAL_TRIP', null);
                    store.commit('SET_ACTUAL_TRIP_METADATA', null);
                    store.commit('SET_CANCELED_TRIP', data.viajeCancelado);
                } else {
                    console.error('ERROR CRÍTICO: El ID del viaje cancelado recibido del servidor no coincide con el ID del viaje actual.');
                }
            } else {
                let history = store.state.tripsHistory.find(item => item.id === data.viajeCancelado.id);
                if (!history) {
                    playNotification(store, data.viajeCancelado.id, 'passengerCanceled', 'cancel_pacman');
                    store.commit('SET_CANCELED_TRIP', data.viajeCancelado);
                    store.commit('ADD_HISTORY_TRIP', data.viajeCancelado);
                }
            }
        }
        cancelarVisto();
    }
    if (data.viaje_timeout) {
        // Timeout trip
        let history = store.state.tripsHistory.find(item => item.id === data.viaje_timeout.id);
        if (!history) {
            playNotification(store, actualTrip.id, 'passengerCanceled', 'cancel_pacman');
            actualTrip.frontState = TRIP_STATE.TIMEOUT;
            store.commit('ADD_HISTORY_TRIP', actualTrip);
            store.commit('SET_ACTUAL_TRIP', null);
        }
    }
    if (data.choferes) {
        store.dispatch('availableDriverPosition', data.choferes);
    }
    if (data.mensajes) {
        globalStore.commit('messages/SET_MESSAGES', data.mensajes); // Cierro sesión
    }
}

let threadMarker = null;
let threadAction = function ({ next, times, data, register }) {
    // TODO: Renable for production
    // TODO: Uncomment
    // TODO: Renable for production
    // let store = data;
    // store.commit('MOVE_ONE_STEP');
    next();
};

function availableDriverPosition (store, data) {
    store.commit('SET_AVAILABLE_DRIVERS', data);
    if (!threadMarker) {
        threadMarker = new Thread({ interval: 200, runImmediately: true });
        threadMarker.action(threadAction).tag('moving-marker').run(store);
    } else {
        // Thread.stopThreads('moving-marker');
        // threadMarker = null;
    }
}

function cancelarVisto (store) {
    let action = () => { return pasajeroApi.markCancelTrip(); };
    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        // Cancel succes
        return true;
    }).catch((err) => {
        /**
         * No se pudo realizar la conexion despues de tantos intentos
         * Alertar al usuario y volver al estado atrás.
         */
        console.error(err);
        return byPassError(err);
    });
}

function abortLastCheckState (store) {
    pasajeroApi.net.abort('check-state');
}

function init (store, flag) {
    let threadAction = function ({ next, times, data, register }) {
        let store = data;
        let t = checkState(store).then(() => {
            next();
        }).catch((error) => {
            if (error === undefined) {
                console.error('Probably the last call to state was aborted by system.');
            } else {
                console.error(error);
            }
            next();
        });
        register(t);
    };

    if (flag) {
        let t = new Thread({ interval: 12000, runImmediately: true });
        t.action(threadAction).tag('check-state').run(store);
    } else {
        console.log('stop Threads');
        Thread.stopThreads('check-state');
    }
}

function calculateTripStatics (store, trip) {
    // [TODO] Set timestamps
    let origin = { lat: trip.vehiculo.lat, lng: trip.vehiculo.lng };
    let destination = { lat: trip.lat, lng: trip.lng };
    debounceDirectionsService(store, origin, destination);
}

// Todo make thread que consuma esta acción
function checkState (store) {
    // [TODO] Set timestamps
    let time = store.state.timestamp;
    let position = globalStore.getters['geolocation/actual'];
    let zona = globalStore.getters['geolocation/actualZona'];
    let data = {};
    if (position && position.lat && position.lng && zona) {
        data = {
            lat: position.lat,
            lng: position.lng,
            zona_id: zona.id,
            timestamp: time
        };
    }
    return pasajeroApi.estado(data).then(data => {
        store.commit('SET_TIMESTAMP');
        handleState(store, data);
    }).catch(byPassError);
}

function cancelReservation (store, data = {}) {
    const reservation = data.reservation || store.state.pendingReservation;
    if (!reservation || !reservation.id || !canCancelReservation(reservation)) {
        return Promise.resolve(false);
    }

    const trip = Object.assign({}, reservation, { frontState: TRIP_STATE.CANCELED_BY_USER });
    const hadPending = !!store.state.pendingReservation;
    if (hadPending) {
        store.commit('SET_PENDING_RESERVATION', null);
    }
    store.commit('ADD_HISTORY_TRIP', trip);

    const payload = {
        viaje_id: reservation.id,
        lat: data.lat != null ? data.lat : 0,
        lng: data.lng != null ? data.lng : 0,
        comentario: data.comentario || 'Cancelado por pasajero'
    };

    const action = () => pasajeroApi.cancelTrip(payload);
    return Network.doItInBackground(action, { retries: 10, interval: 5000 }).then(() => {
        checkState(store);
        if (!shouldStayOnReservasRoute()) {
            dialogs.message(LangManager.translate('reservaCanceladaExito'), { duration: 5, estado: 'success' });
        }
        return true;
    }).catch((error) => {
        if (hadPending) {
            store.commit('SET_PENDING_RESERVATION', reservation);
        }
        store.commit('REMOVE_HISTORY_TRIP', trip);
        if (error.status === 422 && error.data === 'No hay viaje para cancelar') {
            checkState(store);
            return true;
        }
        dialogs.message(LangManager.translate('problemaInesperado'), { duration: 10, estado: 'error' });
        return byPassError(error);
    });
}

function cancelTrip (store, data) {
    console.log('store cancelTrip');
    let trip = store.state.actualTrip;
    trip.frontState = TRIP_STATE.CANCELED_BY_USER;
    store.commit('ADD_HISTORY_TRIP', trip);
    store.commit('SET_ACTUAL_TRIP', null);
    store.commit('SET_ACTUAL_TRIP_METADATA', null);

    let action = () => { return pasajeroApi.cancelTrip(data); };
    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        // Cancel succes
        return true;
    }).catch((error) => {
        if (error.status === 422 && error.data === 'No hay viaje para cancelar') {
            return true; // [ToDo] HANDLE -> el chofer cancelo antes
        } else {
            /**
             * No se pudo realizar la conexion despues de tantos intentos
             * Alertar al usuario y volver al estado atrás.
             */
            console.error(error);
            trip.frontState = TRIP_STATE.ACCEPTED;
            store.commit('SET_ACTUAL_TRIP', trip);
            store.commit('REMOVE_HISTORY_TRIP', trip);
            calculateTripStatics(store, trip);
        }
        return byPassError(error);
    });
}

function rideupTrip (store, data) {
    let trip = store.state.actualTrip;
    if (!reservationAdvanceAllowed(trip)) {
        dialogs.message(reservationAdvanceErrorMessage(trip) || 'Reserva pendiente de pago', { duration: 10, estado: 'error' });
        return;
    }
    trip.frontState = TRIP_STATE.RIDEUP;
    store.commit('SET_ACTUAL_TRIP', trip);

    let action = () => { return pasajeroApi.rideupTrip(data); };
    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        maybeRefreshPassengerUserForBeneficio();
        checkState(store);
        return true;
    }).catch((error) => {
        if (error.status === 422) {
            // Reservation deferred-payment: backend returns { error: '...' }.
            if (error.data && typeof error.data === 'object' && error.data.error) {
                dialogs.message(error.data.error, { duration: 10, estado: 'error' });
                // Revert optimistic UI. Do not cancel the trip.
                trip.frontState = TRIP_STATE.ACCEPTED;
                trip.llegando = false;
                trip.pasajeroAbordo = false;
                store.commit('SET_ACTUAL_TRIP', trip);
                return;
            }
            let reason = '';
            if (error.data === 'No hay viaje para abordar.') {
                reason = LangManager.translate('viajeDoesntExist');
            } else if (error.data && error.data.message && error.data.message === 'Viaje cancelado por el chofer.') {
                trip.frontState = TRIP_STATE.CANCELED_BY_DRIVER;
                reason = LangManager.translate('viajeCaneladoPorChofer') + error.data.viajeCancelado.comentario_rechazo;
                store.commit('SET_CANCELED_TRIP', error.data.viajeCancelado);
            }
            store.commit('ADD_HISTORY_TRIP', trip);
            store.commit('SET_ACTUAL_TRIP', null);
            store.commit('SET_ACTUAL_TRIP_METADATA', null);
            dialogs.message(reason, { duration: 10, estado: 'error' });
        } else {
            /**
             * No se pudo realizar la conexion despues de tantos intentos
             * Alertar al usuario y volver al estado atrás.
             */
            console.error(error);
            trip.frontState = TRIP_STATE.ACCEPTED;
            store.commit('SET_ACTUAL_TRIP', trip);
        }
        return byPassError(error);
    });
}
function arrivedToDestination (store) {
    let trip = store.state.actualTrip;
    if (!reservationAdvanceAllowed(trip)) {
        dialogs.message(reservationAdvanceErrorMessage(trip) || 'Reserva programada', { duration: 10, estado: 'error' });
        return;
    }
    trip.frontState = TRIP_STATE.ARRIVED_TO_DESTINATION;
    store.commit('SET_ACTUAL_TRIP', trip);
}
function setRequestPosition (store, position) {
    store.commit('SET_REQUEST_POSITION', position);
}

function endTrip (store, data) {
    let trip = store.state.actualTrip;
    trip.frontState = TRIP_STATE.FINISH;
    store.commit('ADD_HISTORY_TRIP', trip);
    store.commit('SET_ACTUAL_TRIP', null);
    store.commit('SET_ACTUAL_TRIP_METADATA', null);
    maybeRefreshPassengerUserForBeneficio();
    globalStore.dispatch('messages/endChat');

    let action = () => { return pasajeroApi.endTrip(data); };
    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        // Cancel succes
        return true;
    }).catch((error) => {
        if (error.status === 422) {
            let reason = '';
            if (error.data === 'No hay viaje para finalizar.') {
                reason = LangManager.translate('viajeDoesntExist');
            } else if (error.data && error.data.message && error.data.message === 'Viaje cancelado por el chofer.') {
                store.commit('REMOVE_HISTORY_TRIP', trip);
                trip.frontState = TRIP_STATE.CANCELED_BY_DRIVER;
                store.commit('ADD_HISTORY_TRIP', trip);
                reason = LangManager.translate('viajeCaneladoPorChofer') + error.data.viajeCancelado.comentario_rechazo;
                store.commit('SET_CANCELED_TRIP', error.data.viajeCancelado);
            }
            dialogs.message(reason, { duration: 10, estado: 'error' });
        } else {
            /**
             * No se pudo realizar la conexion despues de tantos intentos
             * Alertar al usuario y volver al estado atrás.
             */
            console.error(error);
            trip.frontState = TRIP_STATE.RIDEUP;
            store.commit('SET_ACTUAL_TRIP', trip);
            store.commit('REMOVE_HISTORY_TRIP', trip);
            // calculateTripStatics(store, trip); -> Dato innecesario en rideup
        }
        return byPassError(error);
    });
}

export default {
    resetState,
    init,
    createTrip,
    crearPreferenciaReserva,
    checkState,
    cancelTrip,
    cancelReservation,
    rideupTrip,
    endTrip,
    arrivedToDestination,
    handlerNotification,
    upgradeChofer,
    setRequestPosition,
    availableDriverPosition,
    cancelarVisto,
    getBeneficiosCatalogo,
    crearTarjetaBeneficio,
    getMisTarjetasBeneficio,
    canjearTarjetaBeneficio
};



// WEBPACK FOOTER //
// ./src/store/modules/passenger/actions.js